package app

import SettingRoute
import base.SRProps
import community.containers.*
import diagnosis.container.DiagnosisPageProps
import diagnosis.container.DiagnosisPageProvider
import home.HomePageProps
import home.HomePageProvider
import layout.page
import medicalRecord.containers.MedicalRecordEditPageProps
import medicalRecord.containers.MedicalRecordEditPageProvider
import medicalRecord.containers.MedicalRecordsPageProvider
import org.w3c.dom.url.URLSearchParams
import react.*
import react.dom.div
import react.router.dom.route
import react.router.dom.switch
import learning.containers.*
import acupoint.containers.AcupointListPageProvider
import acupoint.containers.AcupointDetailPageProvider
import acupoint.containers.AcupointDetailPageProps
import acupoint.containers.AcupointEditPageProvider
import acupoint.containers.AcupointEditPageProps
import acupoint.containers.AcupointNoteEditPageProvider
import acupoint.containers.AcupointNoteEditPageProps
import settings.diagnosisSetting.containers.DiagnosisSettingPageProps
import settings.diagnosisSetting.containers.DiagnosisSettingPageProvider
import signSymptom.containers.*
import medicine.containers.*
import prescription.containers.*
import settings.syndrome.containers.SyndromeSettingPageProvider
import smartTcm.containers.SmartTcmWaitingAreaPageProvider
import user.containers.LoginPageProps
import user.containers.loginPage
import user.containers.registerPage

data class AppContextData(var placeHolderFunction: (param: String) -> Unit)

val App = functionalComponent<SRProps> { props ->

    val defaultProps = props.defaultProps

    switch {

        route(DefaultRoute.Home.link.url,exact = true){
            page("home-wrapper", ActiveMenuPath(Menu.首页)) {
                child(HomePageProvider, defaultProps as HomePageProps) {}
            }
        }

        //体征症状列表
        /*route<SignSymptomListPageProps>(SmartTcmRoute.DifferentiationRuleList.link.url, exact = true) { routeProps ->
            page("differentiation-rule-list-wrapper", ActiveMenuPath(Menu.智能中医, DefaultSubMenu.辩证管理, SmartTcmRoute.DifferentiationRuleList.link)) {
                child(DifferentiationRuleListPageProvider) {
                    attrs {
                    }
                }
            }
        }*/

        //体征症状列表
        route<SignSymptomListPageProps>(SmartTcmRoute.SignSymptomList.link.url, exact = true) { routeProps ->
            page("sign-symptom-list-wrapper", ActiveMenuPath(Menu.一起学中医, DefaultSubMenu.经方学习, SmartTcmRoute.SignSymptomList.link)) {
                child(SignSymptomListPageProvider) {
                    attrs {
                    }
                }
            }
        }

        //体征症状详情
        route<SignSymptomDetailPageProps>(SmartTcmRoute.SignSymptomDetail.link.url, exact = true) { routeProps ->
            page("sign-symptom-detail-wrapper", ActiveMenuPath(Menu.一起学中医, DefaultSubMenu.经方学习, SmartTcmRoute.SignSymptomDetail.link)) {
                child(SignSymptomDetailPageProvider) {
                    attrs {
                        id = routeProps.match.params.id
                    }
                }
            }
        }

        //体征症状编辑
        route<SignSymptomEditPageProps>(SmartTcmRoute.SignSymptomEdit.link.url, exact = true) { routeProps ->
            page("sign-symptom-edit-wrapper", ActiveMenuPath(Menu.一起学中医, DefaultSubMenu.经方学习, SmartTcmRoute.SignSymptomEdit.link)) {
                child(SignSymptomEditPageProvider) {
                    attrs {
                        id = routeProps.match.params.id
                    }
                }
            }
        }

        //候诊区
        route(SmartTcmRoute.WaitingArea.link.url,exact = true){
            page("smartTcm-waitingArea-wrapper", ActiveMenuPath(Menu.诊疗中心,DefaultSubMenu.我的诊室,SmartTcmRoute.WaitingArea.link)) {
                child(SmartTcmWaitingAreaPageProvider) {
                    attrs {

                    }
                }
            }
        }

        //诊断
        route<DiagnosisPageProps>(SmartTcmRoute.Diagnosis.link.url,exact = true){ routeProps ->
            page("smartTcm-diagnosis-wrapper", ActiveMenuPath(Menu.诊疗中心,DefaultSubMenu.我的诊室,SmartTcmRoute.Diagnosis.link)) {
                child(DiagnosisPageProvider) {
                    attrs {
                        medicalRecordId = routeProps.match.params.medicalRecordId
                    }
                }
            }
        }

        //症状选择器
        /*route(SmartTcmRoute.SymptomChecker.link.url,exact = true){
            page("smartTcm-index-wrapper", ActiveMenuPath(Menu.智能中医,DefaultSubMenu.诊疗中心,SmartTcmRoute.SymptomChecker.link)) {
                child(SmartTcmIndexPageProvider) {
                    attrs {

                    }
                }
            }
        }*/

        //精读伤寒论
        route(LearningRoute.ShanghanlunReading.link.url,exact = true){
            page("study-shanghanlun-reading-wrapper", ActiveMenuPath(Menu.一起学中医,DefaultSubMenu.经方学习,LearningRoute.ShanghanlunReading.link)) {
                child(ShangHanLunReadingPageProvider) {
                    attrs {

                    }
                }
            }
        }

        //条文详情
        route<ShanghanlunDetailPageProps>(LearningRoute.ShanghanlunDetail.link.url, exact = true) { routeProps ->
            page("shanghanlun-detail-wrapper", ActiveMenuPath(Menu.一起学中医, DefaultSubMenu.经方学习, LearningRoute.ShanghanlunDetail.link)) {
                child(ShanghanlunDetailPageProvider) {
                    attrs {
                        id = routeProps.match.params.id
                    }
                }
            }
        }

        //经方医案
        route(LearningRoute.MedicalRecordList.link.url,exact = true){
            page("study-shanghanlun-reading-wrapper", ActiveMenuPath(Menu.一起学中医,DefaultSubMenu.经方学习,LearningRoute.MedicalRecordList.link)) {
                child(MedicalRecordsPageProvider) {
                    attrs {

                    }
                }
            }
        }

        //经方医案编辑
        route<MedicalRecordEditPageProps>(LearningRoute.MedicalRecordEdit.link.url, exact = true) { routeProps ->
            page("medical-record-edit-wrapper", ActiveMenuPath(Menu.一起学中医, DefaultSubMenu.经方学习, LearningRoute.MedicalRecordEdit.link)) {
                child(MedicalRecordEditPageProvider) {
                    attrs {
                        id = routeProps.match.params.id
                    }
                }
            }
        }

        // ...existing code...

        //经方医话
       /* route(CommunityRoute.Topics.link.url,exact = true){
            page("community-qna-wrapper", ActiveMenuPath(Menu.一起学中医,DefaultSubMenu.学习指南,CommunityRoute.Topics.link)) {
                child(TopicsPageProvider) {
                    attrs {

                    }
                }
            }
        }*/


        /*route<TopicViewPageProps>(CommunityRoute.TopicView.link.url,exact = true){ routeProps ->
            page("topic-view-wrapper", ActiveMenuPath(Menu.一起学中医,DefaultSubMenu.学习指南,CommunityRoute.TopicView.link)) {
                child(TopicViewPageProvider) {
                    attrs {
                        id = routeProps.match.params.id
                    }
                }
            }
        }*/

        //学习指南
        route(LearningRoute.Guidelines.link.url,exact = true){
            page("learning-tcmfaq-wrapper", ActiveMenuPath(Menu.一起学中医,DefaultSubMenu.学习指南,LearningRoute.Guidelines.link)) {
                child(GuideLinesPageProvider) {
                    attrs {

                    }
                }
            }
        }


        route<GuidelineEditPageProps>(LearningRoute.GuidelineEdit.link.url,exact = true){ routeProps ->
            page("learning-guideline-edit-wrapper", ActiveMenuPath(Menu.一起学中医,DefaultSubMenu.学习指南,LearningRoute.GuidelineEdit.link)) {
                child(GuidelineEditPageProvider) {
                    attrs {
                        id = routeProps.match.params.id
                    }
                }
            }
        }

        //中医常见问题
        route(LearningRoute.TcmFaq.link.url,exact = true){
            page("learning-tcmfaq-wrapper", ActiveMenuPath(Menu.一起学中医,DefaultSubMenu.学习指南,LearningRoute.TcmFaq.link)) {
                child(TcmFaqsPageProvider) {
                    attrs {

                    }
                }
            }
        }

        /**
         * 查看TCMFAQ
         */
        route<TcmFaqViewPageProps>(LearningRoute.TcmFaqView.link.url,exact = true){ routeProps ->
            page("learning-tcmfaq-view-wrapper", ActiveMenuPath(Menu.一起学中医,DefaultSubMenu.学习指南,LearningRoute.TcmFaqView.link)) {
                child(TcmFaqViewPageProvider) {
                    attrs {
                        id = routeProps.match.params.id
                    }
                }
            }
        }


        //编辑常见问题
        route<TcmFaqEditPageProps>(LearningRoute.TcmFaqEdit.link.url,exact = true){ routeProps ->
            page("learning-tcmfaq-wrapper", ActiveMenuPath(Menu.一起学中医,DefaultSubMenu.学习指南,LearningRoute.TcmFaqEdit.link)) {
                child(TcmFaqEditPageProvider) {
                    attrs {
                        id = routeProps.match.params.id
                    }
                }
            }
        }

        //回答常见问题
        route<TopicCommentEditPageProps>(LearningRoute.TcmFaqAnswerEdit.link.url,exact = true){ routeProps ->
            page("learning-tcmfaq-comment-edit-wrapper", ActiveMenuPath(Menu.一起学中医,DefaultSubMenu.学习指南,LearningRoute.TcmFaqAnswerEdit.link)) {
                child(TcmFaqCommentEditPageProvider) {
                    attrs {
                        topicId = routeProps.match.params.topicId
                        commentId = routeProps.match.params.commentId
                    }
                }
            }
        }


        //十四经络
        route<MeridiansPageProps>(LearningRoute.Meridians.link.url,exact = true){ routeProps ->
            page("meridians-wrapper", ActiveMenuPath(Menu.一起学中医,DefaultSubMenu.针灸学习,LearningRoute.Meridians.link)) {
                child(MeridiansPageProvider) {
                    attrs {

                    }
                }
            }
        }

        //经络编辑
        route<MeridianEditPageProps>(LearningRoute.MeridianEdit.link.url,exact = true){ routeProps ->
            page("meridian-edit-wrapper", ActiveMenuPath(Menu.一起学中医,DefaultSubMenu.针灸学习,LearningRoute.MeridianEdit.link)) {
                child(MeridianEditPageProvider) {
                    attrs {
                        id = routeProps.match.params.id
                    }
                }
            }
        }

        //穴位列表
        route(LearningRoute.AcupointList.link.url,exact = true){
            page("acupoint-list-wrapper", ActiveMenuPath(Menu.一起学中医,DefaultSubMenu.针灸学习,LearningRoute.AcupointList.link)) {
                child(AcupointListPageProvider) {
                    attrs {
                    }
                }
            }
        }

        //穴位详情
        route<AcupointDetailPageProps>(LearningRoute.AcupointDetail.link.url, exact = true) { routeProps ->
            page("acupoint-detail-wrapper", ActiveMenuPath(Menu.一起学中医, DefaultSubMenu.针灸学习, LearningRoute.AcupointDetail.link)) {
                child(AcupointDetailPageProvider) {
                    attrs {
                        id = routeProps.match.params.id
                    }
                }
            }
        }

        //穴位编辑
        route<AcupointEditPageProps>(LearningRoute.AcupointEdit.link.url, exact = true) { routeProps ->
            page("acupoint-edit-wrapper", ActiveMenuPath(Menu.一起学中医, DefaultSubMenu.针灸学习, LearningRoute.AcupointEdit.link)) {
                child(AcupointEditPageProvider) {
                    attrs {
                        id = routeProps.match.params.id
                    }
                }
            }
        }

        //穴位笔记编辑
        route<AcupointNoteEditPageProps>(LearningRoute.AcupointNoteEdit.link.url, exact = true) { routeProps ->
            page("acupoint-note-edit-wrapper", ActiveMenuPath(Menu.一起学中医, DefaultSubMenu.针灸学习, LearningRoute.AcupointNoteEdit.link)) {
                child(AcupointNoteEditPageProvider) {
                    attrs {
                        acupointId = routeProps.match.params.acupointId
                        noteId = routeProps.match.params.noteId
                    }
                }
            }
        }

        //中药列表
        route<MedicineListPageProps>(SmartTcmRoute.MedicineList.link.url, exact = true) { routeProps ->
            page("medicine-list-wrapper", ActiveMenuPath(Menu.一起学中医, DefaultSubMenu.方药学习, SmartTcmRoute.MedicineList.link)) {
                child(MedicineListPageProvider) {
                    attrs {
                    }
                }
            }
        }

        //中药详情
        route<MedicineDetailPageProps>(SmartTcmRoute.MedicineDetail.link.url, exact = true) { routeProps ->
            page("medicine-detail-wrapper", ActiveMenuPath(Menu.一起学中医, DefaultSubMenu.方药学习, SmartTcmRoute.MedicineDetail.link)) {
                child(MedicineDetailPageProvider) {
                    attrs {
                        id = routeProps.match.params.id
                    }
                }
            }
        }

        //中药编辑
        route<MedicineEditPageProps>(SmartTcmRoute.MedicineEdit.link.url, exact = true) { routeProps ->
            page("medicine-edit-wrapper", ActiveMenuPath(Menu.一起学中医, DefaultSubMenu.方药学习, SmartTcmRoute.MedicineEdit.link)) {
                child(MedicineEditPageProvider) {
                    attrs {
                        id = routeProps.match.params.id
                    }
                }
            }
        }

        //方剂列表
        route<PrescriptionListPageProps>(LearningRoute.PrescriptionList.link.url, exact = true) { routeProps ->
            page("prescription-list-wrapper", ActiveMenuPath(Menu.一起学中医, DefaultSubMenu.方药学习, LearningRoute.PrescriptionList.link)) {
                child(PrescriptionListPageProvider) {
                    attrs {
                    }
                }
            }
        }

        //方剂详情
        route<PrescriptionDetailPageProps>(LearningRoute.PrescriptionDetail.link.url, exact = true) { routeProps ->
            page("prescription-detail-wrapper", ActiveMenuPath(Menu.一起学中医, DefaultSubMenu.方药学习, LearningRoute.PrescriptionDetail.link)) {
                child(PrescriptionDetailPageProvider) {
                    attrs {
                        id = routeProps.match.params.id
                    }
                }
            }
        }

        //方剂编辑
        route<PrescriptionEditPageProps>(LearningRoute.PrescriptionEdit.link.url, exact = true) { routeProps ->
            page("prescription-edit-wrapper", ActiveMenuPath(Menu.一起学中医, DefaultSubMenu.方药学习, LearningRoute.PrescriptionEdit.link)) {
                child(PrescriptionEditPageProvider) {
                    attrs {
                        id = routeProps.match.params.id
                    }
                }
            }
        }


        //症状及诊查设置
        route<DiagnosisSettingPageProps>(SettingRoute.DiagnosisSetting.link.url,exact = true){ routeProps ->
            page("setting-symptom-wrapper", ActiveMenuPath(Menu.设置,DefaultSubMenu.应用设置,SettingRoute.DiagnosisSetting.link)) {
                child(DiagnosisSettingPageProvider) {
                    attrs {
                        //id = routeProps.match.params.id
                    }
                }
            }
        }

        //病证列表
        route(SettingRoute.SyndromeSetting.link.url,exact = true){
            page("settings-syndrome-list-wrapper", ActiveMenuPath(Menu.设置,DefaultSubMenu.应用设置,SettingRoute.SyndromeSetting.link)) {
                child(SyndromeSettingPageProvider) {
                    attrs {

                    }
                }
            }
        }

        //评论话题
        /*route<TopicCommentEditPageProps>(CommunityRoute.TopicCommentEdit.link.url,exact = true){ routeProps ->
            page("topic-comment-edit-wrapper", ActiveMenuPath(Menu.一起学中医,DefaultSubMenu.学习指南,CommunityRoute.TopicCommentEdit.link)) {
                child(TopicCommentEditPageProvider) {
                    attrs {
                        topicId = routeProps.match.params.topicId
                        commentId = routeProps.match.params.commentId
                    }
                }
            }
        }*/


        //关于我们
        /*route(DefaultRoute.AboutUs.link.url,exact = true){
            page("about-us-wrapper", ActiveMenuPath(Menu.关于我们)) {
                child(AboutUs::class) {
                    attrs {

                    }
                }
            }
        }*/

        //支持贡献
        /*route(DefaultRoute.Contribution.link.url,exact = true){
            page("contribution-wrapper", ActiveMenuPath(Menu.支持贡献)) {
                child(ContributionPageProvider) {
                    attrs {

                    }
                }
            }
        }*/

        //登录页面
        route<LoginPageProps>(UserRoute.Login.link.url,exact = true) { props ->
            val params = URLSearchParams(props.location.search)
            div {
                loginPage(params.get("redirectUrl")?:DefaultRoute.Home.link.url)
            }
        }

        //注册页面
        route<LoginPageProps>(UserRoute.Register.link.url,exact = true) { props ->
            val params = URLSearchParams(props.location.search)
            div {
                registerPage(params.get("redirectUrl")?:DefaultRoute.Home.link.url)
            }
        }

    }
}

fun RBuilder.app(props:SRProps) = child(App,props) {}